/* Owner round 3: what a design profile is, above the applied profile's details. */
.explain {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
}
